// <s-pdp-bundle>: "steamer only" vs "bundle" picker. The accessory list is always visible.
// Ticking or unticking an accessory (or changing its variant) selects the bundle option.
// Keeps the bundle total and savings line up to date with the ticked accessories.
// s-product-form.js adds the ticked input[data-bundle-line] as extra cart lines, only while the bundle option is selected.
class SPdpBundle extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('change', (event) => this.#update(event.target), { signal: this.#ac.signal });
    this.#update(null);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #format(cents) {
    const locale = document.documentElement.lang || 'nl';
    const currency = this.dataset.currency || 'EUR';
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  }

  #update(target) {
    const bundleRadio = this.querySelector('[data-bundle-mode][value="bundle"]');

    if (target instanceof HTMLSelectElement && target.dataset.bundleVariantFor) {
      const checkbox = this.querySelector(`#${CSS.escape(target.dataset.bundleVariantFor)}`);
      if (checkbox) {
        checkbox.value = target.value;
        checkbox.checked = true;
        // The chosen variant brings its own live price and compare-at price.
        const option = target.selectedOptions[0];
        if (option?.dataset.price) checkbox.dataset.price = option.dataset.price;
        if (option?.dataset.was) checkbox.dataset.was = option.dataset.was;
        const id = CSS.escape(target.dataset.bundleVariantFor);
        const priceEl = this.querySelector(`[data-bundle-price-for="${id}"]`);
        const wasEl = this.querySelector(`[data-bundle-was-for="${id}"]`);
        if (priceEl && option?.dataset.priceLabel) priceEl.textContent = option.dataset.priceLabel;
        if (wasEl) {
          wasEl.hidden = !option?.dataset.wasLabel;
          if (option?.dataset.wasLabel) wasEl.textContent = option.dataset.wasLabel;
        }
      }
      const newImage = target.selectedOptions[0]?.dataset.image;
      const rowImage = this.querySelector(`[data-bundle-img-for="${CSS.escape(target.dataset.bundleVariantFor)}"] img`);
      if (newImage && rowImage) {
        rowImage.removeAttribute('srcset');
        rowImage.src = newImage;
      }
    }

    const touchedAccessory =
      (target instanceof HTMLInputElement && target.matches('[data-bundle-line]')) ||
      (target instanceof HTMLSelectElement && target.dataset.bundleVariantFor);
    if (touchedAccessory && bundleRadio) bundleRadio.checked = true;

    // Each line carries its own (website) price (data-price, data-bundle-base); with nothing ticked the steamer costs its normal price.
    const anyTicked = this.querySelector("input[data-bundle-line]:checked");
    let total = anyTicked && this.dataset.bundleBase ? Number(this.dataset.bundleBase) : Number(this.dataset.basePrice) || 0;
    let was = Number(this.dataset.baseWas) || total;
    this.querySelectorAll('input[data-bundle-line]').forEach((checkbox) => {
      if (!checkbox.checked) return;
      total += Number(checkbox.dataset.price) || 0;
      was += Number(checkbox.dataset.was) || 0;
    });

    const totalEl = this.querySelector('[data-bundle-total]');
    const wasEl = this.querySelector('[data-bundle-was]');
    if (totalEl) totalEl.textContent = this.#format(total);
    if (wasEl) {
      wasEl.textContent = this.#format(was);
      wasEl.hidden = was <= total;
    }

    const saveEl = this.querySelector('[data-bundle-save]');
    if (saveEl) {
      const show = was > total;
      saveEl.classList.toggle('hidden', !show);
      saveEl.textContent = show ? (this.dataset.saveLabel || '').replace('__AMOUNT__', this.#format(was - total)) : '';
    }
  }
}

if (!customElements.get('s-pdp-bundle')) customElements.define('s-pdp-bundle', SPdpBundle);
